// extracted by mini-css-extract-plugin
export default {"container":"addimageprofile_container__3IzH-","onethird":"addimageprofile_onethird__+RRSD","twothirds":"addimageprofile_twothirds__h7vj4"};